import { Component } from '@angular/core';

@Component({
  selector: 'app-contact-page',
  template: `
    <app-page-section padding="sm">
      <div class="relative rounded-3xl px-4 py-14 sm:px-8 sm:py-16 lg:px-14 lg:py-16 overflow-hidden" style="background: linear-gradient(to bottom, #f5f7f9 0%, #fafbfc 50%, #ffffff 100%)">
      <div class="sm:text-center">
        <h1 class="text-balance">Contactez-nous</h1>
        <p class="mt-6 text-pretty max-w-xl sm:mx-auto">location-salles.ch est la plateforme de réservation éditée par ercos. Selon votre besoin, choisissez le bon interlocuteur ci-dessous.</p>
      </div>

      <div class="mt-12 grid grid-cols-1 gap-16 md:grid-cols-2 md:max-w-[70%] mx-auto">
        <app-public-info-card icon="magnifying-glass" variant="ghost">
          <span title>Vous avez une question à propos<br>d'une salle</span>
          <span description>Chaque salle est gérée directement par son hôte. Pour les disponibilités, les tarifs ou une visite, contactez-le depuis sa page — ses coordonnées figurent en bas de l'annonce.</span>
          <div footer>
            <a routerLink="/louer-salle">
              <app-button variant="outlined">Voir l'annuaire des salles</app-button>
            </a>
          </div>
        </app-public-info-card>

        <app-public-info-card icon="laptop" variant="ghost">
          <span title>Vous êtes propriétaire de salle ?</span>
          <span description>Renseignez-vous sur notre logiciel de réservation : démo, mise en place ou toute question sur la plateforme location-salles.ch.</span>
          <div footer class="flex flex-wrap items-center gap-2 text-sm text-gray-600">
            <a class="no-underline text-gray-600" href="mailto:contact@ercos.ch">contact&#64;ercos.ch</a>
            <span class="text-gray-300">|</span>
            <a class="no-underline text-gray-600" href="tel:0215253060">021 525 30 60</a>
            <span class="text-gray-300">|</span>
            <a class="no-underline text-gray-600" href="https://www.ercos.ch" target="_blank">ercos.ch</a>
          </div>
        </app-public-info-card>
      </div>
      </div>
    </app-page-section>

    <app-page-section>
      <h2 class="text-center">Pour aller plus loin</h2>

      <div
        class="mx-auto mt-20 grid w-full grid-cols-1 gap-12 sm:w-3/4 lg:w-full lg:grid-cols-2 lg:gap-16"
      >
        <app-contact-card
          badgeText="tester"
          title="Créer un compte"
          image="creer-compte.webp"
          link="/auth/devenir-un-hote"
        ></app-contact-card>

        <app-contact-card
          badgeText="consulter"
          title="Annuaire<br>location-salles.ch"
          image="annuaire.webp"
          link="/louer-salle"
        ></app-contact-card>
      </div>
    </app-page-section>
  `,
  styles: ``,
  standalone: false,
})
export class ContactPageComponent {}
